"use strict";
/**
 * Outline → durable Task materialize (dogfood).
 *
 * - Promote T body → Info Document is server Rule D (promote-t-notes).
 * - Link▾ New Task: checkbox + child under I + `<t: id>` back-link.
 * - Soft caption stuff when child body still matches previous clean label.
 *
 * See docs/product/action-flow-planning.md §5A and outline-thread-links.md.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.firstLineCaption = exports.materializeOutlineTaskOnBullet = exports.shouldStuffCaption = exports.normalizeCaptionText = exports.cleanOutlineTaskLabel = exports.canPromoteTNotes = exports.hostAllowsOutlineNewTask = exports.isHumanTimerTRow = void 0;
var outlineThreadLink_1 = require("./outlineThreadLink");
var T_TOPICS = new Set([
    'start',
    'travel',
    'break',
    'pack up',
    'session',
    'coding',
    'meeting',
    'walk',
]);
/**
 * Best-effort: is this row a human Actual (T)?
 * Prefer pnFlowKind; else Activity/Start-style heuristics (mirror Python).
 */
function isHumanTimerTRow(row) {
    if (!row)
        return false;
    var fk = row.pnFlowKind != null ? String(row.pnFlowKind).trim().toUpperCase() : '';
    if (fk === 'T')
        return true;
    if (fk && fk !== 'T')
        return false;
    var tg = String(row.pnTaskGroup || '')
        .trim()
        .toLowerCase();
    var tpg = String(row.pnTopicGroup || '')
        .trim()
        .toLowerCase();
    if (['info', 'audit', 'schedule', 'escalated', 'inventory', 'logistics', 'note', 'idea', 'risk'].indexOf(tg) >= 0) {
        return false;
    }
    if (['info', 'note', 'document', 'kb', 'task'].indexOf(tpg) >= 0) {
        return false;
    }
    if (tg === 'session' && (tpg === 'shift' || tpg === 'sign off' || tpg === 'finish' || tpg === 'end')) {
        return false;
    }
    if (tg === 'activity' || tg === 'travel') {
        if (!tpg || T_TOPICS.has(tpg) || tpg.indexOf('start') === 0) {
            return true;
        }
        // Activity + Task is a work item (I), not a timer
        if (tpg === 'task')
            return false;
        return true;
    }
    return false;
}
exports.isHumanTimerTRow = isHumanTimerTRow;
/** Link▾ New Task allowed when map host is a durable non-T note. */
function hostAllowsOutlineNewTask(row) {
    if (!row || row.ID == null || row.ID === '')
        return false;
    return !isHumanTimerTRow(row);
}
exports.hostAllowsOutlineNewTask = hostAllowsOutlineNewTask;
/**
 * Row can offer "Add info / document" / "Add as task parent".
 * Only critical on human timer T Actuals with notes — not I / Document / Activity Task hosts
 * (those use outline Link▾ New Task instead). Keep out of the way for non-T rows.
 */
function canPromoteTNotes(row) {
    if (!row || row.ID == null || row.ID === '')
        return false;
    var body = row.pnBody != null ? String(row.pnBody) : '';
    if (!body.trim())
        return false;
    return isHumanTimerTRow(row);
}
exports.canPromoteTNotes = canPromoteTNotes;
function cleanOutlineTaskLabel(label) {
    var cleanLabel = (0, outlineThreadLink_1.parseOutlineThreadLinks)(label).cleanLabel;
    return cleanLabel.replace(/\s+/g, ' ').trim();
}
exports.cleanOutlineTaskLabel = cleanOutlineTaskLabel;
function normalizeCaptionText(value) {
    if (value == null)
        return '';
    return String(value).replace(/\s+/g, ' ').trim();
}
exports.normalizeCaptionText = normalizeCaptionText;
/**
 * Soft sync gate: stuff new outline caption into child only if child still equals prev clean label.
 */
function shouldStuffCaption(prevClean, nextClean, childBody) {
    var p = normalizeCaptionText(prevClean);
    var n = normalizeCaptionText(nextClean);
    var c = normalizeCaptionText(childBody);
    if (!n || n === p)
        return false;
    if (!p)
        return false;
    return c === p;
}
exports.shouldStuffCaption = shouldStuffCaption;
/**
 * Ensure checkbox open (if none) and append `<t: pnid>` on the bullet.
 * Returns new doc or null if bullet missing.
 */
function materializeOutlineTaskOnBullet(doc, bulletId, taskPnid) {
    var found = false;
    var lines = doc.lines.map(function (l) {
        if (l.kind !== 'bullet' || l.id !== bulletId)
            return l;
        found = true;
        var bullet = l;
        var checkbox = bullet.checkbox == null ? 'open' : bullet.checkbox;
        var label = (0, outlineThreadLink_1.appendOutlineThreadLink)(bullet.label, taskPnid);
        return __assign(__assign({}, bullet), { checkbox: checkbox, label: label });
    });
    if (!found)
        return null;
    return { lines: lines };
}
exports.materializeOutlineTaskOnBullet = materializeOutlineTaskOnBullet;
/** First non-empty meaningful line for promote caption (client-side preview). */
function firstLineCaption(body, maxLen) {
    if (maxLen === void 0) { maxLen = 120; }
    if (!body)
        return 'Document';
    for (var _i = 0, _a = String(body).split(/\r?\n/); _i < _a.length; _i++) {
        var raw = _a[_i];
        var s = raw.trim();
        if (!s)
            continue;
        s = s.replace(/^[-*+]\s+/, '');
        s = s.replace(/^\[([ xX])\]\s*/, '');
        s = s.replace(/<t:\s*\d+\s*>/gi, '');
        s = s.replace(/\s+\(\+\)$/, '').trim();
        s = s.replace(/\s+/g, ' ');
        if (s)
            return s.length > maxLen ? s.slice(0, maxLen) : s;
    }
    return 'Document';
}
exports.firstLineCaption = firstLineCaption;
